export default {
  index () {
    document.addEventListener('DOMContentLoaded', () => {
      this._setDeleteStaffEventHandler()
    }, false)
  },
  _setDeleteStaffEventHandler () {
    document.querySelectorAll('.btn-delete').forEach((e) => {
      e.addEventListener("click", () => {
        if (!window.confirm("本当に削除しますか？")) {
          return false
        }
        window.location.href = e.dataset.value
      })
    })
  }
}
